import { hbs } from 'ember-cli-htmlbars';
export default hbs("<li class=\"hamburger-menu__item\">\n  <a href={{@url}}>{{yield}}</a>\n</li>")